import apiClient from '../../lib/apiClient';
import { ContentResponse } from './types/shared';

const contentQueryKey = (locationKey: string) => ['content', locationKey];
const fetchContent: (locationKey: string) => Promise<ContentResponse> = async (locationKey) => {
  const contentResponse = await apiClient.fetch(location.href, `/api/contentbyurl${locationKey}`);

  return contentResponse.json();
};

export const contentQueryOptions = (locationKey: string) => ({
  queryKey: contentQueryKey(locationKey),
  queryFn: () => fetchContent(locationKey),
  staleTime: 1000 * 60 * 1,
});
